import request from '@/api/request'

const MyorderList = (params) => {
  // 订单列表
  return request({
    url: '/api/v1/app/trade/order/pagingOrderInfo',
    method: 'GET',
    params
  })
}

const causeorder = (params) => {
  // 订单取消原因
  return request({
    url: '/api/v1/app/trade/order/getOrderCancelReason',
    method: 'GET',
    params
  })
}
const cancelorder = (data) => {
  // 取消订单
  return request({
    url: '/api/v1/app/trade/order/cancel',
    method: 'POST',
    data
  })
}

const pagingOrderAftermarket = (params) => {
  // 订单售后申请列表
  return request({
    url: '/api/v1/app/trade/order/pagingAftermarketOrder',
    method: 'GET',
    params
  })
}

const oredrdetail = (params) => {
  // 订单详情查询
  return request({
    url: '/api/v1/app/trade/order/queryOrderInfo',
    method: 'GET',
    params
  })
}

const orderlogistics = (params) => {
  // 订单物流查询
  return request({
    url: '/api/v1/app/trade/order/queryExpressByItemId',
    method: 'GET',
    params
  })
}

const arrive = (data) => {
  // 确认收货
  return request({
    url: '/api/v1/app/trade/order/arrive',
    method: 'POST',
    data
  })
}

const queryTradeFlowByOrderId = (params) => {
  // 订单交易流水
  return request({
    url: '/api/v1/app/trade/order/queryTradeFlowByOrderId',
    method: 'GET',
    params
  })
}

const orderDelete = (params) => {
  // 删除订单
  return request({
    url: '/api/v1/app/trade/order/deletedOrder',
    method: 'DELETE',
    params
  })
}

export default {
  MyorderList,
  cancelorder,
  oredrdetail,
  orderlogistics,
  causeorder,
  arrive,
  pagingOrderAftermarket,
  queryTradeFlowByOrderId,
  orderDelete
}
